<template>
  <!-- 商品类型选择 -->
  <!-- <el-form-item :prop="prop"> -->
  <el-cascader
    :options="options"
    :placeholder="inputPlaceholder || $t('app.pleaseSelectProductType')"
    @change="changeProduct"
    :props="{ checkStrictly: true }"
    clearable
    v-model="result"
    ref="cascader"
  ></el-cascader>
  <!-- </el-form-item> -->
</template>

<script>
import { getProductModel } from "@/api/AccountInterface";
import {
    getRepairProductModel
} from "@/api/SquirrelSettlement";
export default {
  data() {
    return {
      options: [],
      result: []
    };
  },
  props: {
    inputPlaceholder: {
      type: String,
      default: ""
    },
    prop: {
      type: String,
      default: ""
    },
    snFilter:{
      type:Boolean,
      default:false,
    }
  },
  methods: {
    // 切换商品类型
    changeProduct(node) {
      let modelParentId = null;
      let modelId = null;
      this.result = [];
      console.log(node, "node");
      if (node.length == 1) {
        modelParentId = node[0];
        this.result = [modelParentId];
      } else if (node.length == 2) {
        modelParentId = node[0];
        modelId = node[1];
        this.result = [modelParentId, modelId];
      }
      console.log(this.result);
      this.$emit("changeP", this.result);
      // this.$emit("input", result);
    },
    async initOptions() {
      let ret 
      if(this.snFilter){
        ret = await getRepairProductModel()
      }else{
        ret = await getProductModel()
      }
      if (ret.code === 0) {
          if (ret.data.length > 0) {
           
            let result = ret.data.map(e => {
              let tempList = e.childModelList.map(e2 => {
                return {
                  label: e2.modelName,
                  value: e2.modelId
                };
              });
              return {
                label: e.modelName,
                value: e.modelId,
                children: tempList
              };
            });
            if(this.snFilter){
              result = result.filter((item, index, array) => {
                return item.value != 104 && item.value != 106 && item.value != 107 && item.value != 108
              })
            }
            this.options = result;
            console.log(this.options);
          }
      }
    },
    resetCascaderInput() {
      this.result = [];
    }
  },
  mounted() {
    this.initOptions();
  }
};
</script>

<style lang="scss" scoped></style>
